import { createDomain, updateDomain } from "./domainManagementService";

export const CardTypes = {
    CREATE: "CREATE",
    EDIT: "EDIT"
}

export class domainNameCardService {

    constructor(cardType, handleClose) {
        this.cardType = cardType || CardTypes.CREATE;
        this.handleClose = handleClose;
    }

    onCreate = async (data) => {
        await createDomain(data);
        this.handleClose();
    }

    onSave = async (data) => {
        await updateDomain(data);
        this.handleClose();
    }


}
